import { AssetManagementMessages } from '../utils/asset-management-messages.utils';
import { AssetManagementLabels } from '../enums/asset-management-reports.enum';
import { ReportPeriod } from '../models/report-period';
import {
  AssetManagementRequestParams,
  BatchUpdateCategoryAccountEntry,
  CategoryAccountRequest,
  AssetManagementFileSources,
} from '../models';
import { AccountMappingDialogData } from '../components/account-mapping-management-dialog/account-mapping-management-dialog.component';
import { AccountMapping } from '../models/account-mapping';
import { AssetMetadata } from '../models/asset-metadata';

export namespace AssetManagementActions {
  export class LoadGeneralLedger {
    static readonly type = AssetManagementMessages.Actions.LOAD(AssetManagementLabels.GeneralLedger);

    constructor(public accountingReportParams: AssetManagementRequestParams) {}
  }

  export class ImportGeneralLedger {
    static readonly type = AssetManagementMessages.Actions.IMPORT(AssetManagementLabels.GeneralLedger);

    constructor(
      public file: File,
      public source: AssetManagementFileSources,
    ) {}
  }

  export class LoadTrialBalance {
    static readonly type = AssetManagementMessages.Actions.LOAD(AssetManagementLabels.TrialBalance);

    constructor(public accountingReportParams: AssetManagementRequestParams) {}
  }

  export class LoadBalanceSheet {
    static readonly type = AssetManagementMessages.Actions.LOAD(AssetManagementLabels.BalanceSheet);

    constructor(public reportPeriod: ReportPeriod) {}
  }

  export class LoadIncomeStatement {
    static readonly type = AssetManagementMessages.Actions.LOAD(AssetManagementLabels.IncomeStatement);

    constructor(public reportPeriod: ReportPeriod) {}
  }

  export class LoadRegularAccounts {
    static readonly type = AssetManagementMessages.Actions.LOAD(AssetManagementLabels.RegularAccount);
  }

  export class CreateAccountMapping {
    static readonly type = AssetManagementMessages.Actions.CREATE(AssetManagementLabels.AccountMapping);
    constructor(
      public accountTreeId: number,
      public accountMappingRequest: Required<AccountMappingDialogData>,
    ) {}
  }

  export class UpdateAccountMapping {
    static readonly type = AssetManagementMessages.Actions.UPDATE(AssetManagementLabels.AccountMapping);
    constructor(
      public accountTreeId: number,
      public accountMappingRequest: Required<AccountMappingDialogData>,
    ) {}
  }

  export class LoadAccountMappings {
    static readonly type = AssetManagementMessages.Actions.LOAD(AssetManagementLabels.AccountMapping);
    constructor(
      public accountTreeId: number,
      public accountingReportParams: AssetManagementRequestParams,
    ) {}
  }

  export class DeleteAccountMapping {
    static readonly type = AssetManagementMessages.Actions.DELETE(AssetManagementLabels.AccountMapping);
    constructor(
      public accountTreeId: number,
      public accountMapping: AccountMapping,
    ) {}
  }

  export class LoadCategoryAccounts {
    static readonly type = AssetManagementMessages.Actions.LOAD(AssetManagementLabels.CategoryAccount);
  }

  export class CreateCategoryAccount {
    static readonly type = AssetManagementMessages.Actions.CREATE(AssetManagementLabels.CategoryAccount);

    constructor(public categoryAccountRequest: CategoryAccountRequest) {}
  }

  export class UpdateCategoryAccount {
    static readonly type = AssetManagementMessages.Actions.UPDATE(AssetManagementLabels.CategoryAccount);

    constructor(public categoryAccountRequest: CategoryAccountRequest) {}
  }

  export class DeleteCategoryAccount {
    static readonly type = AssetManagementMessages.Actions.DELETE(AssetManagementLabels.CategoryAccounts);

    constructor(public categoryAccountRequest: CategoryAccountRequest) {}
  }

  export class UpdateCategoryAccounts {
    static readonly type = AssetManagementMessages.Actions.UPDATE(AssetManagementLabels.CategoryAccounts);

    constructor(public categoryAccounts: BatchUpdateCategoryAccountEntry[]) {}
  }

  export class ImportChartOfAccounts {
    static readonly type = AssetManagementMessages.Actions.IMPORT(AssetManagementLabels.ChartOfAccounts);
    constructor(
      public accountTreeId: number,
      public file: File,
    ) {}
  }

  export class LoadAccountTrees {
    static readonly type = AssetManagementMessages.Actions.LOAD(AssetManagementLabels.AccountTree);
  }

  export class LoadAssetBudget {
    static readonly type = AssetManagementMessages.Actions.LOAD(AssetManagementLabels.AssetBudget);

    constructor(public reportPeriod: ReportPeriod) {}
  }

  export class LoadTrailingIncomeStatement {
    static readonly type = AssetManagementMessages.Actions.LOAD(AssetManagementLabels.TrailingIncomeStatement);

    constructor(public reportPeriod: ReportPeriod) {}
  }

  export class SetAssetMetadata {
    static readonly type = AssetManagementMessages.Actions.SET('Asset Metadata');

    constructor(public assetMetadata: AssetMetadata) {}
  }

  export class Clear {
    static readonly type = '[Asset Management] Clear State';
  }
}
